import React from 'react'

const DetailsNotFound = (props) => {
    const { handleDetailsNotFoundFlow } = props;
    const handleVerifyClick = () => {
        // Add logic for verify button click
        handleDetailsNotFoundFlow();
    };

    return (
        <div className='mt-3'>
            <h6 style={{ fontSize: "20px", fontWeight: "600", lineHeight: "30px", textAlign: "left", color: "#101828" }}>Details not found</h6>
            <p style={{ fontSize: "18px", fontWeight: "400", lineHeight: "21.24px", textAlign: "left", color: "#101828" }}>
                Unfortunately, we are not able to find any record associated with the details you mentioned.
            </p>
            <div className="btn-box d-flex justify-content-between w-100 h-100 p-1 pt-3" style={{ maxWidth: "422px", }}>
                <div className="btn w-100 btn-primary text-light" onClick={handleVerifyClick} style={{ cursor: "pointer" }}>Continue</div>
            </div>
        </div>
    )
}

export default DetailsNotFound